<template>
    <section id="steps-uid-6-p-0" role="tabpanel" aria-labelledby="steps-uid-6-h-0" class="body current" aria-hidden="false">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group" v-if="!uploading">
                    <label for="documents">Upload Pictures</label>
                    <input type="file" class="form-control" id="documents" ref="file" accept=".JPG,.JPEG,.PNG" @change="handleFileChange">
                </div>
                <div class="form-group text-center" v-if="uploading">
                    <i class="fa fa-spinner fa-2x"></i> Uploading File
                </div>
            </div>
        </div>
        <div class="row" v-if="specification.documents.length > 0">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="document_list">Uploaded Pictures</label>
                    <ul class="select2-selection__rendered custom-flex" id="document_list">
                        <li :id="document.filepath" class="selection-choice2" v-for="(document, index) in specification.documents">
                            {{document.filename}} <span class="select-remove" @click="deleteFile(index)"> ×</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import uuid from "uuid/v4";
    import {mapGetters} from "vuex";
    import axios from 'axios';

    export default {
        name: "AllOffers",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                offerid: null,
                uploading: false,
                specification: this.$parent.specification
            }
        },
        mounted() {
            this.offerid = uuid();
        },
        methods: {
            async handleFileChange() {
                this.uploading = true;
                let file       = this.$refs.file.files[0];
                let filename   = file.name;
                let signedUrl  = await this.getUploadUrl(this.offerid, filename);
                let uploaded   = await this.uploadFile(signedUrl.data.url, file);
                this.specification.documents.push({
                    filename: filename,
                    filepath: signedUrl.data.key,
                    contenttype: file.type.split('/')[1]
                });
                this.$refs.file.value = '';
            },
            async getUploadUrl(offerid, filename) {
                return await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/offers/${offerid}/signedUrl`, {
                    params: {
                        name: filename,
                        type: 'write'
                    }
                });
            },
            async getDownloadUrl(index) {
                let filepath = this.specification.documents[index].filepath;
                let result   = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/offers/${this.offerid}/signedUrl`, {
                    params: {
                        type: 'read',
                        key: filepath
                    }
                });

                window.location.href = result.data.url;
            },
            async uploadFile(signedUrl, file) {
                await axios.put(signedUrl, file);
                this.uploading = false;
            },
            deleteFile(index) {
                console.log(index);
            }
        }
    }
</script>

<style scoped>
    .selection-choice2 {
        background-color: #e4e4e4;
        border-radius: 4px;
        cursor: default;
        float: left;
        margin-right: 5px;
        margin-top: 5px;
        padding: 6px 8px;
        color: #3e5569
    }

    .custom-flex {
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        padding: 0
    }

    .select-remove {
        color: #999;
        cursor: pointer;
        display: inline-block;
        font-weight: bold;
        margin-right: 1px;
        margin-left: 5px;
    }

    .select-remove:hover {
        color: #333
    }

    .wizard > .content > .body ul > li {
         list-style: none;
    }
</style>
